<template>
  <div class="guanLianBox">
    <el-dialog v-loading="loading" title="添加货物" :visible.sync="addVisible" :close-on-click-modal="false" width="90%"
      center :before-close="guanLianQuXiao">
      <!--输入框-->
      <div class="guanLianBox-input">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData">
          <el-form-item label="捆包号:">
            <el-input type="textarea" v-model="formData.cargoBarcodes" placeholder="请输入" size="mini"
              style="width:150px;vertical-align:top;"></el-input>
          </el-form-item>
          <el-form-item label="出库时间:">
            <el-date-picker v-model="formData.outstockDateStart" size="mini" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker> -
            <el-date-picker v-model="formData.outstockDateStartEnd" size="mini" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="规格:">
            <el-input v-model="formData.specification" placeholder="请输入" size="mini" style="width:135px;"></el-input>
          </el-form-item>
          <el-form-item label="出库车牌号:">
            <el-input v-model="formData.outstockPlateNumber" placeholder="请输入" size="mini" style="width:135px;">
            </el-input>
          </el-form-item>
          <el-form-item label="出库司机:">
            <el-input v-model="formData.driverName" placeholder="请输入" size="mini" style="width:135px;"></el-input>
          </el-form-item>
          <el-form-item label="出库单编号:">
            <el-input v-model="formData.outstockNo" placeholder="请输入" size="mini" style="width:135px;"></el-input>
          </el-form-item>
          <el-form-item label="客户名称:">
            <el-select size="mini" filterable clearable v-model="formData.customerNameTaxId" placeholder="请选择">
              <el-option v-for="(item,index) in kehuMing" :label="item.custerName" :key="index"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库客户:">
            <el-select size="mini" filterable clearable v-model="formData.inCustomerTaxId" placeholder="请选择">
              <el-option v-for="(item,index) in kehuMing" :label="item.custerName" :key="index"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[13]" btnCode="003M320F00">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[14]" btnCode="003M320G00">重置
            </el-button>
            <span style="margin-left:10px">已选：<span style="color:red;">{{allNumber}}</span> 件,&nbsp;&nbsp;<span
                style="color:red">{{allWeight}}</span> 吨</span>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table size="mini" ref="tabref" :data="relevanceTableData" height="40vh"
          :header-cell-style="{background:'#F5F5F5',color:'black'}" @selection-change="selectGoods" border center
          bordersize="mini">
          <el-table-column type="selection" align="center"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" v-for="item in titleList" :key="item.titleName"
            :prop="item.titleId instanceof Array ?'':item.titleId" :label="item.titleName" align="center"
            :width="item.titleId=='customerName'||item.titleId=='cargoBarcode'||item.titleId=='payCustomerName'||item.titleId=='outstockNo'||item.titleId=='instockDate'||item.titleId=='outstockDate'||item.titleId=='contractNumber'||item.titleId=='agreementNumber'||item.titleId=='inCustomerName'?220:120">
            <template v-if="item.titleId instanceof Array ? true : false">
              <el-table-column v-for="item in item.titleId" :key="item.titleId" :prop="item.titleId"
                :label="item.titleName"></el-table-column>
            </template>
          </el-table-column>
          <!-- <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量（吨）" align="center" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeType" label="费用类型" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="amount" label="金额" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="stockDay" label="库存天数" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="changeNumber" label="转货次数" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="ext1" label="到货方式" align="center" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="出库车牌号" align="center" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="driverName" label="出库司机" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockNo" label="出库单编号" align="center" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库时间" align="center" width="200"></el-table-column> -->

          <!-- <el-table-column :show-overflow-tooltip="true" prop="overduePrice" label="超期单价" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="storageFee" label="仓储费" align="center" width="120">
            <template v-slot="scope">
            <div>
              <span>{{Number(scope.row.storageFee).toFixed(3)}}</span>
            </div>
          </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeStateName" label="结算状态" align="center" width="120"></el-table-column> -->

        </el-table>
        <!--分页-->
        <div class="pags" style="text-align: right;">
          <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize"
            :page-sizes="[50,100,200,500,1000]" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" :total="total"></el-pagination>
        </div>
      </div>
      <div style="width:158px;margin:20px auto;">
        <el-button type="primary" @click="guanlianOk" :disabled="isDisable">确定</el-button>
        <el-button type="primary" @click="guanLianQuXiao">取消</el-button>
      </div>
    </el-dialog>
    <!--点击查看凭证-->
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <!-- <div v-if="!imgFlag">
            <div>无货损图片</div>
          </div>-->
        <div class="img_box">
          <div v-for="(item, index) in imgData" :key="index">
            <img :src="item.url" alt />
            <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)"></i> -->
            <i class="el-icon-zoom-in" @click="handChange(item.url)"></i>
          </div>
        </div>
        <el-dialog class="oneTwo" :visible.sync="dialogVisible" title="查看凭证" append-to-body width="40%" center
          :close-on-click-modal="false">
          <div class="imgDialog">
            <img :src="imageD" alt />
          </div>
        </el-dialog>
        <div style="width: 158px; margin: 15px auto"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {
    JfgetStorageFeeList,
    getRelationCustomer
  } from '@/api/wms-stock'
  import {
    getCargoDamagePicture // 查看图片
  } from '@/api/wms-access'
  import DonMessage from '@/utils/message'
  import {
    getBtn
  } from '@/utils/getButton'

  export default {
    name: 'addDialog',
    data() {
      return {
        loading: false,
        formData: {
          cargoBarcodes: '',
          outstockDateStart: '',
          outstockDateStartEnd: '',
          specification: '',
          outstockPlateNumber: '',
          driverName: '',
          feeMasterId: -1,
          outstockNo: '',
          customerNameTaxId: '',
          inCustomerTaxId: ''
        },
        pageNo: 1,
        pageSize: 50,
        relevanceTableData: [],
        total: 0,
        isDisable: false,
        selectedTable: [],
        addMarkLookBox: false,
        imageD: '',
        dialogVisible: false,
        imgData: [],
        btnFlg: [],
         btnIdArr: [
          '003M320200',
          '003M320300',
          '003M320400',
          '003M320500',
          '003M320600',
          '003M320700',
          '003M320800',
          '003M320900',
          '003M320A00',
          '003M320B00',
          '003M320C00',
          '003M320D00',
          '003M320E00',
          '003M320F00',
          '003M320G00',
          '003M320H00',
          '003M320I00',
          '003M320J00',
          '003M320K00',
          '003M320L00',
          '003M320M00',
          '003M320N00',
          '003M320O00',
          '003M320P00',
          '003M320Q00',
          '003M320R00',
          '003M320S00',
          '003M320T00',
          '003M320U00',
          '003M320V00',

        ],
        titleList: [],
        allNumber: 0,
        allWeight: 0,
        kehuMing: []
      }
    },
    props: {
      addVisible: {
        type: Boolean,
        default: false
      },
      customerName: {
        type: String
      },
      delCargoBarcodes: {
        type: String,
        default: ''
      }
    },
    methods: {
      getRelationCustomerS() {
        getRelationCustomer({
            // groupNo: "change_status"
          })
          .then((res) => {
            this.kehuMing = res
          })
          .catch((err) => {
            DonMessage.error(err.message)
          })
      },
      // 查看凭证-放大
      handChange(url) {
        this.imageD = url
        this.dialogVisible = true
      },
      // 图片查看
      imgShow(row) {
        this.addMarkLookBox = true
        getCargoDamagePicture({
            cargoId: row.cargoId // 货物id
          })
          .then((res) => {
            this.imgData = []
            this.imgData = res
          })
          .catch((err) => {
            DonMessage.error(err.message)
          })
      },
      // 选择数据
      selectGoods(selection) {
        this.allNumber = selection.length
        this.allWeight = selection.reduce((pre, cur) => (pre / 1 + cur.weight / 1).toFixed(3), 0)
        this.selectedTable = selection
      },
      handleCurrentChange(val) {
        this.pageNo = val
        this.chaxun()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.chaxun()
      },
      chaxun() {
        this.formData.cargoBarcodes = this.formData.cargoBarcodes.replace(/\n/g, ',')

        JfgetStorageFeeList({
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            payCustomerNameTaxId: this.customerName,
            delCargoBarcodes: this.delCargoBarcodes,
            ...this.formData
          })
          .then(res => {
            console.log(res)
            this.relevanceTableData = res.feeList.list
            this.titleList = res.titleList
            this.total = res.feeList.total
          })
          .catch(error => {
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
      },
      chongzhi() {
        this.formData = {
          cargoBarcodes: '',
          outstockDateStart: '',
          outstockDateStartEnd: '',
          specification: '',
          outstockPlateNumber: '',
          driverName: '',
          feeMasterId: -1,
          outstockNo: '',
          customerNameTaxId: '',
          inCustomerTaxId: ''
        }
        this.chaxun()
      },
      guanlianOk() {
        this.$emit('gettables', this.selectedTable)
        // this.$emit('gettitle', this.titleList)
        this.$emit('update:addVisible', false)
      },
      guanLianQuXiao() {
        this.$emit('update:addVisible', false)
      }
    },
    created() {
      this.getRelationCustomerS()
      this.chaxun()
      this.btnFlg = getBtn(this.btnIdArr, '/billManagement')
    },
    mounted() {}
  }

</script>

<style lang="less" scoped>
  /deep/ .el-form-item {
    margin: 0px;
  }

</style>
